import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router';

import PageBase from '../../../app/PageBase';
import Table from '../../table/MsTable';
import { getWorkflowsByHoldingId } from '../../../redux/actions/workflowActions';


import { setWorkflowData } from '../../../redux/workflow';
import { BooleanNormalize } from '../../normalize';

const mapStateToProps = state => ({
  open: state.workflowReducer.open,
  workflowId: state.workflowReducer.workflowId,
  workflowList: state.workflowReducer.workflowList,
});

const mapDispatchToProps = {
  setWorkflowData,
  getWorkflowsByHoldingId,
};

class WorkflowContainer extends Component {


  static propTypes = {

  };

  constructor(props) {

    super(props);

    this.state = {

    };


  }


  componentWillMount() {

    this.getWorkflows();

  }

  getWorkflows() {

    const { getWorkflowsByHoldingId, user, setWorkflowData } = this.props;

    getWorkflowsByHoldingId(user.context.idHolding).then(response => setWorkflowData({ workflowList: response }));

  }


  handleCreateClick = () => this.props.history.push('/flow/incompleteList/');


  handleClose = () => {

    this.props.setWorkflowData({ open: false, workflowData: null });
    this.setState({ data: {}, showTableActions: false });

  }

  handleCloseAndReload = () => {

    this.props.setWorkflowData({ open: false, workflowData: null });
    this.setState({ data: {}, showTableActions: false });
    this.getWorkflows();

  }


  render() {

    const { workflowList, open } = this.props;
    const { showTableActions, deleteOpen } = this.state;


    return (
      <div>
        {!deleteOpen && (
          <PageBase
            title={I18n.t('menu.workflowList')}
            navigation={`Configurações -> ${I18n.t('menu.users')}`}
            showCreateButton={!showTableActions}
            showEditButton={false}
            showDeleteButton={false}
            handleCreateClick={this.handleCreateClick}
            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
          >
            {
              workflowList && (
                <Table
                  data={workflowList}
                  entryKey="workFlowId"
                  selectable={false}
                  paginate
                  onPaginate={this.onPaginate}
                  toolbar
                  onSelectionChange={this.onChangeData}
                  onSwitchChange={this.onSwitchChange}
                  tableDef={[
                    { name: 'name', label: I18n.t('fields.name') },
                    { name: 'companyName', label: I18n.t('fields.company') },
                    { name: 'active', label: I18n.t('fields.active'), normalizer: BooleanNormalize },
                  ]}
                />
              )
            }


          </PageBase>
        )
        }


      </div>
    );

  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkflowContainer));



// WEBPACK FOOTER //
// ./src/components/tracker/Flow/WorkflowContainer.js